module.exports = __webpack_public_path__ + "static/media/DSC07439.e0fa88c4.jpg";